import type { QSet } from '@exam-management/graphql';
import { Text, type GridColDef } from '@shared/components';
import { formatDateTime, formatSecondsToHoursMinutes } from '@shared/utils';

export interface QSetColumn {
  id: QSet['id'];
  code: QSet['code'];
  qConfig: {
    code: QSet['qConfig']['code'];
    totalQuestions: QSet['qConfig']['totalQuestions'];
    timeLimit: QSet['qConfig']['timeLimit'];
  };
  updatedAt: QSet['updatedAt'];
}

export const columns: GridColDef<QSetColumn>[] = [
  {
    field: 'code',
    headerName: 'QSetID',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => {
      return <Text>{row.code}</Text>;
    },
  },
  {
    field: 'qConfigId',
    headerName: 'QConfigID',
    width: 120,
    sortable: false,
    renderCell: ({ row }) => {
      return <Text>{row.qConfig.code}</Text>;
    },
  },
  {
    field: 'examDetail',
    headerName: 'Exam Details',
    sortable: false,
    width: 200,
    renderCell: ({ row }) => {
      const { totalQuestions, timeLimit } = row.qConfig;

      const examTimeLimit = timeLimit?.total
        ? formatSecondsToHoursMinutes(timeLimit.total, 'TEXT')
        : '-';

      return (
        <Text>
          {totalQuestions} ข้อ ({`${examTimeLimit}`})
        </Text>
      );
    },
  },
  {
    field: 'updatedAt',
    headerName: 'Last Modified',
    sortable: false,
    width: 180,
    renderCell: ({ row }) => {
      return <Text>{formatDateTime(row.updatedAt)}</Text>;
    },
  },
];
